import { chainCommands } from 'prosemirror-commands';
import { nodeInputRule } from '../../../utils/inputrules';
import { withLogAction } from '../../../utils/keymap';
import { YfmNoteSpecs } from './YfmNoteSpecs';
import { createYfmNote, toYfmNote } from './actions/toYfmNote';
import { backToNoteTitle, exitFromNoteTitle, removeNote } from './commands';
import { noteType } from './utils';
import './index.css';
const noteAction = 'toYfmNote';
export { YfmNoteNode, noteType, noteTitleType } from './YfmNoteSpecs';
export const YfmNote = (builder, opts) => {
    builder.use(YfmNoteSpecs, opts);
    builder
        .addKeymap(() => ({
        Enter: exitFromNoteTitle,
        Backspace: chainCommands(backToNoteTitle, removeNote),
    }))
        .addAction(noteAction, () => toYfmNote)
        .addInputRules(({ schema }) => ({
        rules: [nodeInputRule(/(?:^)({% note)\s$/, noteType(schema).createAndFill(), 1)],
    }));
    if (opts === null || opts === void 0 ? void 0 : opts.yfmNoteKey) {
        const { yfmNoteKey } = opts;
        builder.addKeymap(() => ({ [yfmNoteKey]: withLogAction('yfm_note', createYfmNote) }));
    }
};
